import React from 'react';
import { observer, inject } from 'mobx-react'

const WelcomeHero = inject('userStore')(observer(props => {
  const { name } = props.userStore.state
  return (
    <section className='hero is-info is-small'>
      <div className='hero-body'>
        <div className='container'>
          <h1 className="title">
            Olá {name}
          </h1>
          <h2 className="subtitle">
            Bem vindo ao Portal de Produtos Letnis
          </h2>
        </div>
      </div>
    </section> 
  )
}))

export default WelcomeHero



// WEBPACK FOOTER //
// ./src/components/dashboard/WelcomeHero.js